export default {
  plural: 'Images',
  singular: 'Image',
  singularWithExtensions: 'Image (.jpg, .jpeg, .png)',
  main: 'Main image'
};
